import { Module } from "vuex";
import { RootState } from "../types";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { BddState } from "./types";

export const state: BddState = {
  userId: localStorage.user ? JSON.parse(localStorage.user).id : "",
};

const namespaced: boolean = true;

export const bdd: Module<BddState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
